<template>
   <div class="like-btn-container" @click="toggleActivity">
    <div class="circle-bg"></div>
    <svg id="Component_8_1" :class='"Component_8_1" + content.objectid' data-name="Component 8 – 1"
      xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" >

      <g filter="url(#filter0_b_792_2497)">
        <circle cx="24" cy="24" r="24" fill="white" fill-opacity="0.3" />
      </g>
    
      <path
        d="M16.1017 33.7136C15.9549 33.7136 15.8081 33.7136 15.6613 33.7216C14.8232 33.7884 14.2627 33.2519 14.2733 32.4111C14.3054 30.0435 14.3321 27.676 14.3614 25.3111C14.3774 24.1206 14.6871 23.819 15.8802 23.819C16.9051 23.819 17.9274 23.827 18.9524 23.8083C19.0805 23.8083 19.2327 23.6749 19.3261 23.5628C19.6651 23.1597 19.9854 22.7433 20.311 22.3269C21.6723 20.584 22.7293 18.6862 23.3085 16.5402C23.458 15.9823 23.5808 15.4165 23.7169 14.8533C23.7916 14.5436 24.1199 14.2794 24.4376 14.2714C26.0391 14.2287 27.3923 15.4565 27.2722 17.1087C27.1815 18.3632 26.7651 19.5937 26.4928 20.8349C26.4928 20.8349 26.4928 20.8402 26.4928 20.8429C26.4127 21.1979 26.717 21.5182 27.0774 21.4595C27.2162 21.4381 27.355 21.4221 27.4911 21.4194C28.6522 21.4007 29.8213 21.3287 30.969 21.4568C32.1541 21.5902 32.72 22.4871 32.9549 23.5975C33.3579 25.5033 33.3312 27.4037 32.7894 29.2721C32.4851 30.3238 32.1808 31.4048 31.6737 32.363C31.0358 33.5642 29.7652 34.1087 28.5187 34.0927C27.2802 34.0766 26.0417 34.0286 24.8032 33.9672C23.5647 33.9031 22.3262 33.8257 21.0904 33.7537C20.7007 33.7296 20.311 33.7083 19.9213 33.6843L18.8617 33.727M20.0628 32.1388C20.0628 32.4111 20.2763 32.6353 20.5486 32.6513C21.0023 32.6753 21.4214 32.6967 21.8431 32.71C24.0078 32.7714 26.1752 32.9182 28.3345 32.8462C29.6825 32.8008 30.993 32.2242 30.7982 30.4546C30.7822 30.3184 30.9263 30.1343 31.0438 30.0222C31.6523 29.4403 31.8178 28.757 31.6096 27.9482C31.5669 27.7774 31.5803 27.5372 31.671 27.3957C32.1648 26.6296 32.1968 25.893 31.6924 25.1109C31.5776 24.9347 31.5642 24.6091 31.6417 24.4036C32.0153 23.3839 31.687 22.6419 30.614 22.5992C29.2741 22.5458 27.9182 22.6472 26.5836 22.8127C25.5079 22.9462 25.1476 22.722 25.2383 21.5769C25.3371 20.3197 25.7588 19.0919 26.023 17.8481C26.1805 17.1034 26.2286 16.356 25.5479 15.8195C25.3531 15.6674 25.1849 15.5339 24.9527 15.654C24.7498 15.7581 24.603 16.5081 24.563 16.6443C23.8717 19.1106 22.7506 21.3687 21.0904 23.3172C20.3697 24.1607 19.9907 24.9881 20.0388 26.1278C20.1215 28.119 20.0735 30.1183 20.0654 32.1442L20.0628 32.1388ZM18.7389 32.2322V25.5113C18.7389 25.2283 18.5093 25.0015 18.2291 25.0015H15.7788C15.4958 25.0015 15.2689 25.231 15.2689 25.5113V32.2322C15.2689 32.5152 15.4985 32.7421 15.7788 32.7421H18.2291C18.512 32.7421 18.7389 32.5125 18.7389 32.2322Z"
        :class='"Path_18" + content.objectid' :fill="liked ? thumbSelectedColor : thumbColor" />
      <defs>
        <filter id="filter0_b_792_2497" x="-6" y="-6" width="60" height="60" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_792_2497" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_792_2497" result="shape" />
        </filter>
      </defs>
    </svg>
  </div>
</template>
  
<script>
import { eventBus } from "@/eventBus";
import { mapGetters } from "vuex";
import firebase from "firebase/app";
import "firebase/database";
import FirebaseActions from "@/mixins/FirebaseActions";
import { _projectName } from "@/provider-config.js";

export default {
  props: {
    content: {
      type: Object,
    },
    likeFireCount: {
      type: Number,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
  data() {
    return {
      liked: false,
      likedColor: null,
      thumbSelectedColor: "#fffd8d",
      noColor: "#161616",
      likeBlackColor: "black",
      thumbColor: "#ffffff",
      currentState: null,
      likeCount: 0,
      contentLikeCount: null,
      dislikeCountDisplay: null,
      applyColor: "clr-red",
      defaultColor: "like",
    };
  },
  watch: {

    contentLikeCount(val) {
      // console.log("contentLikeCount", val);
      this.$emit("likeCount", val);
      // eventBus.$emit("like-count-to-mixin", val);
    },
    likeFireCount(val) {
      console.log("content from parent", val);
    },
    content(val) {
      // console.log("watch content in like", val);
      this.fetchButtonState();
      this.getContentLikeCount();
      this.getContentDislikeCount();
    },
    subscriberid(val) {
      if (val) {
        this.fetchButtonState();
      }
    },
  },
  computed: {
    ...mapGetters(["subscriberid", "profileid"]),
  },
  mounted() {
    // document.getElementsByClassName(`Component_8_1${this.content.objectid}`)[0].addEventListener("mouseover", () => {
    //   document.getElementsByClassName(`Path_18${this.content.objectid}`)[0].setAttribute("fill", "white")
    // });

    // document.getElementsByClassName(`Component_8_1${this.content.objectid}`)[0].addEventListener("mouseout", () => {
    //   if (!this.liked)
    //     document.getElementsByClassName(`Path_18${this.content.objectid}`)[0].setAttribute("fill", "#ffffff")
    // })


    this.getContentLikeCount();
    this.getContentDislikeCount();
    eventBus.$on("updatelikeDislikeStatus", () => {
      console.log("logged In from like no subscriber Button");
    });
  },
  created() {
    this.fetchButtonState();

    this.likedColor = "#010001"
  },
  methods: {
    fetchButtonState() {
      // console.log("entered");
      if (!this.content) return;
      // console.log("content", this.content);
      let content = this.content;

      let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

      if ("seriesid" in content && content.seriesid) {
        // let seriesid = content.seriesid;
        path += `${content.objectid}/episodes/${content.objectid}`;
      } else {
        path += `${content.objectid}`;
      }
      // console.log("button state path", path);
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          let response = snapshot.val();

          if (response && response.likestatus === "LIKE") {
            this.liked = true;
            this.action = "REMOVE";
            this.currentState = "";
          } else if (response && response.likestatus === "DISLIKE") {
            this.action = "ADD";
            this.liked = false;
            console.log("current state from like", response.likestatus);
            this.currentState = "DISLIKE";
          } else {
            this.liked = false;
            this.action = "ADD";
            this.currentState = "";
          }
          // console.log("action in likebtn", this.action);
        });
    },
    getContentLikeCount() {
      let payload = {
        objectid: this.content.objectid,
        type: "like",
      };
      this.fetchLikeDislikeCount(payload).then((result) => {
        if (result) {
          this.contentLikeCount = result;
        } else {
          this.contentLikeCount = 0;
        }
        // this.$emit("likeCount", this.contentLikeCount);
        // eventBus.$emit("like-count-to-mixin", this.contentLikeCount);
      });
    },
    getContentDislikeCount() {
      let payload = {
        objectid: this.content.objectid,
        type: "dislike",
      };
      this.fetchLikeDislikeCount(payload).then((result) => {
        if (result) {
          this.dislikeCountDisplay = result;
        } else {
          this.dislikeCountDisplay = 0;
        }
      });
    },
    toggleActivity() {

      if (this.subscriberid) {
        // this.$emit("updateLikeCount", this.action);
        if (this.action === "ADD" && this.currentState === "") {
          // console.log("add");
          // this.updateContentCount(this.content, this.contentLikeCount, "LIKE");
          this.updateLikeDislikeToFire(this.content, "LIKE");
          //calculate counts
          this.contentLikeCount = this.contentLikeCount + 1;
          this.$emit("likeCount", this.contentLikeCount);
        } else if (this.action === "ADD" && this.currentState === "DISLIKE") {

          // when the content is DISLIKE change the status and count
          console.log("dislikeCountDisplay", this.dislikeCountDisplay);
          this.updateContentCount(
            this.content,
            this.contentLikeCount,
            "LIKE",
            this.dislikeCountDisplay
          );
          this.updateLikeDislikeToFire(this.content, "LIKE");
          this.contentLikeCount = this.contentLikeCount + 1;
          // this.dislikeCountDisplay =
          //   this.dislikeCountDisplay > 0 ? this.dislikeCountDisplay - 1 : 0;
          this.$emit("likeCount", this.contentLikeCount);
          this.$emit("dislikeCount", this.dislikeCountDisplay);
        } else if (this.action === "REMOVE") {

          // console.log("remove");
          this.updateContentCount(
            this.content,
            this.contentLikeCount,
            "REMOVELIKE"
          );
          this.updateLikeDislikeToFire(this.content, "NONE");

          //calculate counts
          this.contentLikeCount =
            this.contentLikeCount > 0 ? this.contentLikeCount - 1 : 0;
          this.$emit("likeCount", this.contentLikeCount);
        }
      } else {
        let payload = {
          state: true,
          formType: "lookup",
        };
        eventBus.$emit("authPopup", payload);
      }
    },
  },
  mixins: [FirebaseActions],
};
</script>
  
<style>

.like-btn-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.circle-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  background-color: transparent;
  border-radius: 50%;
  transition: background-color 0.3s;
  z-index: -1;
  pointer-events: none;
}

.like-btn-container:hover .circle-bg {
  /* background-color: #fff;  */
}

.like-btn-container:hover svg path {
  fill: #ff0000 !important;
}




</style>
  